// 2026-02 (Item A — central HTML-entity fix)
//
// Single shared decoder for maintenance message text. Backend
// write choke-points already clean text at rest via
// `decode_maintenance_text` in `routes/maintenance_availability.py`,
// but this helper stays as defence-in-depth for:
//   * Old rows that predate the migration and haven't been
//     touched since.
//   * Any code path that renders text loaded from a non-cleaned
//     source (e.g. alert bodies persisted before the fix).
//
// Idempotent — running it a second time on already-decoded text
// is a no-op. Used by:
//   * MR conversation thread (`MaintenanceConversationThread`)
//   * MR pending card (`PendingMessagesSection`)
//   * MR card operator-notes callout
//   * Global Pending Messages page (previews + edit prefill)
//   * Dashboard Pending Approvals section previews
//
// Rule 1: no phrase-patching whitelists. `DOMParser` decodes the
// full HTML-entity spec (named + numeric) plus tag stripping.
export const decodeText = (raw) => {
  if (!raw) return '';
  const str = String(raw);
  try {
    const doc = new DOMParser().parseFromString(str, 'text/html');
    const txt = (doc.body && (doc.body.textContent || doc.body.innerText)) || '';
    return txt
      .replace(/\s+\n/g, '\n')
      .replace(/[ \t]{2,}/g, ' ')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  } catch (_e) {
    return str
      .replace(/&nbsp;/gi, ' ')
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;/gi, '"')
      .replace(/&#39;/gi, "'")
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<[^>]+>/g, '')
      .trim();
  }
};

export default decodeText;
